// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.res.mjs";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Css_Legacy_Core from "bs-css/src/Css_Legacy_Core.res.mjs";

function WordFlyersTrophies$Gold(props) {
  var cls1 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "efa82b"
            }),
        tl: /* [] */0
      });
  var cls2 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "ffffd4"
            }),
        tl: /* [] */0
      });
  var cls3 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "ffd145"
            }),
        tl: /* [] */0
      });
  var cls4 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "fdc039"
            }),
        tl: /* [] */0
      });
  var cls5 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "39333a"
            }),
        tl: {
          hd: Css.isolation("isolate"),
          tl: {
            hd: Css.opacity(0.54),
            tl: /* [] */0
          }
        }
      });
  return React.createElement("svg", {
              id: "Layer_1",
              viewBox: "0 0 55.28 45.87",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  className: cls5,
                  d: "M16.79,45.87l.37-2.31c.41-2.56,2.29-4.69,5.13-5.9v-3.4c-.68-.27-1.31-.58-1.92-.94l-.11-.06c-1.39-.83-2.71-1.94-3.91-3.3-5.48-.72-9.71-3-12.59-6.8C-.69,17.27-.25,9.88,.42,6L.95,2.9H9.8c.1-.49,.21-.96,.33-1.41l.4-1.49H44.3l.49,1.47v.05c.14,.44,.26,.9,.36,1.38h9.18l.53,3.1c.66,3.88,1.11,11.27-3.35,17.15-2.73,3.59-8.01,6.29-13.62,6.99-1.51,1.65-3.18,2.91-4.97,3.76v3.74c2.62,1.12,4.48,3.08,5.3,5.62l.84,2.61H16.79ZM45.52,10.36c-.25,3.47-1.02,7.07-2.2,10.35,.88-.57,1.63-1.26,2.24-2.06,1.52-2.01,2.31-4.97,2.24-8.29h-2.28Zm-38.06,0c-.07,3.32,.72,6.28,2.24,8.29,.37,.49,.8,.94,1.27,1.35-.97-3.07-1.56-6.37-1.7-9.63h-1.81Z"
                }), React.createElement("g", undefined, React.createElement("rect", {
                      className: cls1,
                      height: "12.13",
                      width: "6.63",
                      x: "24.29",
                      y: "28.9"
                    }), React.createElement("path", {
                      className: cls1,
                      d: "M17.28,28.04c-5.26-.55-9.27-2.6-11.92-6.1C1.36,16.67,1.78,9.9,2.39,6.34l.25-1.44H13.63v3.46H5.6c-.5,4.56,.39,8.69,2.52,11.5,2.05,2.7,5.25,4.3,9.52,4.75l-.36,3.44h0Z"
                    }), React.createElement("path", {
                      className: cls1,
                      d: "M35.64,28.31c5.96-.18,11.62-2.87,14.27-6.37,4-5.28,3.58-12.04,2.97-15.61l-.25-1.44h-10.99v3.46h8.03c.5,4.56-.39,8.69-2.52,11.5-2.05,2.7-5.25,4.3-9.52,4.75,0,0-1.99,3.71-1.99,3.71Z"
                    }), React.createElement("path", {
                      className: cls3,
                      d: "M12.06,2h30.8c2.91,9.58-3.35,31.2-15.68,31.2S8.94,13.68,12.06,2Z"
                    }), React.createElement("path", {
                      className: cls4,
                      d: "M42.86,2h-12.59c3.79,11.82-2.47,22.36-9.66,29.09,1.92,1.33,4.12,2.11,6.57,2.11,13.07,0,18.59-21.62,15.68-31.2Z"
                    }), React.createElement("path", {
                      className: cls4,
                      d: "M19.14,43.87h17.18c-2.45-7.61-16.17-6.42-17.18,0Z"
                    })), React.createElement("path", {
                  className: cls2,
                  d: "M14.46,4.92c-.61,6.82-.35,13.38,4.72,20.91,.81,.86-4.04-8.24-1.78-15.39,1-3.17,4.71-3.72,10-4.2,1.31-.17,.7-1.14,.17-1.4s-9.45-.35-13.12,.09Z"
                }));
}

var Gold = {
  make: WordFlyersTrophies$Gold
};

function WordFlyersTrophies$Silver(props) {
  var cls1 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "url",
              VAL: "#linear-gradient"
            }),
        tl: /* [] */0
      });
  var cls2 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "f6f8ff"
            }),
        tl: /* [] */0
      });
  var cls3 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "9eb9c5"
            }),
        tl: /* [] */0
      });
  var cls4 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "bbd1d4"
            }),
        tl: /* [] */0
      });
  var cls5 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "c6dad9"
            }),
        tl: /* [] */0
      });
  var cls6 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "url",
              VAL: "#linear-gradient-2"
            }),
        tl: /* [] */0
      });
  var cls7 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "39333a"
            }),
        tl: {
          hd: Css.opacity(0.44),
          tl: /* [] */0
        }
      });
  return React.createElement("svg", {
              id: "Layer_1",
              viewBox: "0 0 55.27 45.87",
              xmlns: "http://www.w3.org/2000/svg",
              xmlnsXlink: "http://www.w3.org/1999/xlink"
            }, React.createElement("title", undefined, "Silver Trophy"), React.createElement("defs", undefined, React.createElement("linearGradient", {
                      id: "linear-gradient",
                      gradientUnits: "userSpaceOnUse",
                      x1: "2.95",
                      x2: "17.01",
                      y1: "17.3",
                      y2: "15.63"
                    }, React.createElement("stop", {
                          offset: ".18",
                          stopColor: "#bbd0ce"
                        }), React.createElement("stop", {
                          offset: "1",
                          stopColor: "#a2aab9"
                        })), React.createElement("linearGradient", {
                      id: "linear-gradient-2",
                      x1: "53.22",
                      x2: "36.65",
                      xlinkHref: "#linear-gradient",
                      y1: "18.99",
                      y2: "14.64"
                    })), React.createElement("path", {
                  className: cls7,
                  d: "M16.79,45.87l.37-2.31c.41-2.56,2.29-4.69,5.13-5.9v-3.4c-.68-.27-1.31-.58-1.92-.94l-.11-.06c-1.39-.83-2.71-1.94-3.91-3.3-5.48-.72-9.71-3-12.59-6.8C-.69,17.27-.25,9.88,.42,6L.95,2.9H9.8c.1-.49,.21-.96,.33-1.41l.4-1.49H44.3l.49,1.47v.05c.14,.44,.26,.9,.36,1.38h9.18l.53,3.1c.66,3.88,1.11,11.27-3.35,17.15-2.73,3.59-8.01,6.29-13.62,6.99-1.51,1.65-3.18,2.91-4.97,3.76v3.74c2.62,1.12,4.48,3.08,5.3,5.62l.84,2.61H16.79ZM45.52,10.36c-.25,3.47-1.02,7.07-2.2,10.35,.88-.57,1.63-1.26,2.24-2.06,1.52-2.01,2.31-4.97,2.24-8.29h-2.28Zm-38.06,0c-.07,3.32,.72,6.28,2.24,8.29,.37,.49,.8,.94,1.27,1.35-.97-3.07-1.56-6.37-1.7-9.63h-1.81Z"
                }), React.createElement("g", undefined, React.createElement("rect", {
                      className: cls3,
                      height: "12.13",
                      width: "6.63",
                      x: "24.29",
                      y: "28.9"
                    }), React.createElement("path", {
                      className: cls1,
                      d: "M17.28,28.04c-5.26-.55-9.27-2.6-11.92-6.1C1.36,16.67,1.78,9.9,2.39,6.34l.25-1.44H13.63v3.46H5.6c-.5,4.56,.39,8.69,2.52,11.5,2.05,2.7,5.25,4.3,9.52,4.75l-.36,3.44Z"
                    }), React.createElement("path", {
                      className: cls6,
                      d: "M35.64,28.31c5.96-.18,11.62-2.87,14.27-6.37,4-5.28,3.58-12.04,2.97-15.61l-.25-1.44h-10.99s0,3.46,0,3.46h8.03c.5,4.56-.39,8.69-2.52,11.5-2.05,2.7-5.25,4.3-9.52,4.75l-1.99,3.71Z"
                    }), React.createElement("path", {
                      className: cls5,
                      d: "M12.06,2h30.8c2.91,9.58-3.35,31.2-15.68,31.2S8.94,13.68,12.06,2Z"
                    }), React.createElement("path", {
                      className: cls4,
                      d: "M42.86,2h-12.59c3.79,11.82-2.47,22.36-9.66,29.09,1.92,1.33,4.12,2.11,6.57,2.11,13.07,0,18.59-21.62,15.68-31.2Z"
                    }), React.createElement("ellipse", {
                      className: cls2,
                      cx: "15.75",
                      cy: "11.88",
                      rx: "1.93",
                      ry: "7.07",
                      transform: "translate(-1.53 2.36) rotate(-8.18)"
                    }), React.createElement("ellipse", {
                      className: cls2,
                      cx: "22.72",
                      cy: "7.13",
                      rx: "2.34",
                      ry: "2.28"
                    }), React.createElement("path", {
                      className: cls4,
                      d: "M19.14,43.87h17.18c-2.45-7.61-16.17-6.42-17.18,0Z"
                    })));
}

var Silver = {
  make: WordFlyersTrophies$Silver
};

function WordFlyersTrophies$Bronze(props) {
  var cls1 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "url",
              VAL: "#linear-gradient"
            }),
        tl: /* [] */0
      });
  var cls2 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "b8654e"
            }),
        tl: /* [] */0
      });
  var cls3 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "d28462"
            }),
        tl: /* [] */0
      });
  var cls4 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "c77959"
            }),
        tl: /* [] */0
      });
  var cls5 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "url",
              VAL: "#linear-gradient-3"
            }),
        tl: /* [] */0
      });
  var cls6 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "url",
              VAL: "#linear-gradient-2"
            }),
        tl: /* [] */0
      });
  var cls7 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "39333a"
            }),
        tl: {
          hd: Css.opacity(0.54),
          tl: /* [] */0
        }
      });
  var cls8 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "ffd398"
            }),
        tl: {
          hd: Css.opacity(0.66),
          tl: /* [] */0
        }
      });
  return React.createElement("svg", {
              id: "Layer_1",
              viewBox: "0 0 55.27 45.87",
              xmlns: "http://www.w3.org/2000/svg",
              xmlnsXlink: "http://www.w3.org/1999/xlink"
            }, React.createElement("title", undefined, "Bronze Trophy"), React.createElement("defs", undefined, React.createElement("linearGradient", {
                      id: "linear-gradient",
                      gradientUnits: "userSpaceOnUse",
                      x1: "4.59",
                      x2: "14.21",
                      y1: "17.94",
                      y2: "15.31"
                    }, React.createElement("stop", {
                          offset: ".13",
                          stopColor: "#d28462"
                        }), React.createElement("stop", {
                          offset: ".88",
                          stopColor: "#c2614a"
                        })), React.createElement("linearGradient", {
                      id: "linear-gradient-2",
                      x1: "50.04",
                      x2: "37.87",
                      xlinkHref: "#linear-gradient",
                      y1: "17.96",
                      y2: "15.16"
                    }), React.createElement("linearGradient", {
                      id: "linear-gradient-3",
                      x1: "18.11",
                      x2: "61.44",
                      xlinkHref: "#linear-gradient",
                      y1: "7.6",
                      y2: "36.06"
                    })), React.createElement("path", {
                  className: cls7,
                  d: "M16.79,45.87l.37-2.31c.41-2.56,2.29-4.69,5.13-5.9v-3.4c-.68-.27-1.31-.58-1.92-.94l-.11-.06c-1.39-.83-2.71-1.94-3.91-3.3-5.48-.72-9.71-3-12.59-6.8C-.69,17.27-.25,9.88,.42,6L.95,2.9H9.8c.1-.49,.21-.96,.33-1.41l.4-1.49H44.3l.49,1.47v.05c.14,.44,.26,.9,.36,1.38h9.18l.53,3.1c.66,3.88,1.11,11.27-3.35,17.15-2.73,3.59-8.01,6.29-13.62,6.99-1.51,1.65-3.18,2.91-4.97,3.76v3.74c2.62,1.12,4.48,3.08,5.3,5.62l.84,2.61H16.79ZM45.52,10.36c-.25,3.47-1.02,7.07-2.2,10.35,.88-.57,1.63-1.26,2.24-2.06,1.52-2.01,2.31-4.97,2.24-8.29h-2.28Zm-38.06,0c-.07,3.32,.72,6.28,2.24,8.29,.37,.49,.8,.94,1.27,1.35-.97-3.07-1.56-6.37-1.7-9.63h-1.81Z"
                }), React.createElement("g", undefined, React.createElement("rect", {
                      className: cls2,
                      height: "12.13",
                      width: "6.63",
                      x: "24.29",
                      y: "28.9"
                    }), React.createElement("path", {
                      className: cls1,
                      d: "M17.28,28.04c-5.26-.55-9.27-2.6-11.92-6.1C1.36,16.67,1.78,9.9,2.39,6.34l.25-1.44H13.63v3.46H5.6c-.5,4.56,.39,8.69,2.52,11.5,2.05,2.7,5.25,4.3,9.52,4.75l-.36,3.44Z"
                    }), React.createElement("path", {
                      className: cls6,
                      d: "M35.64,28.31c5.96-.18,11.62-2.87,14.27-6.37,4-5.28,3.58-12.04,2.97-15.61l-.25-1.44h-10.99s0,3.46,0,3.46h8.03c.5,4.56-.39,8.69-2.52,11.5-2.05,2.7-5.25,4.3-9.52,4.75l-1.99,3.71Z"
                    }), React.createElement("path", {
                      className: cls3,
                      d: "M12.06,2h30.8c2.91,9.58-3.35,31.2-15.68,31.2S8.94,13.68,12.06,2Z"
                    }), React.createElement("path", {
                      className: cls5,
                      d: "M42.86,2h-12.59c3.79,11.82-2.47,22.36-9.66,29.09,1.92,1.33,4.12,2.11,6.57,2.11,13.07,0,18.59-21.62,15.68-31.2Z"
                    }), React.createElement("ellipse", {
                      className: cls8,
                      cx: "15.75",
                      cy: "11.88",
                      rx: "1.93",
                      ry: "7.07",
                      transform: "translate(-1.53 2.36) rotate(-8.18)"
                    }), React.createElement("ellipse", {
                      className: cls8,
                      cx: "22.72",
                      cy: "7.13",
                      rx: "2.34",
                      ry: "2.28"
                    }), React.createElement("path", {
                      className: cls4,
                      d: "M19.14,43.87h17.18c-2.45-7.61-16.17-6.42-17.18,0Z"
                    })));
}

var Bronze = {
  make: WordFlyersTrophies$Bronze
};

function WordFlyersTrophies$Glass(props) {
  var cls1 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "ffffff"
            }),
        tl: /* [] */0
      });
  var cls2 = Curry._1(Css.style, {
        hd: Css_Legacy_Core.SVG.fill({
              NAME: "hex",
              VAL: "ffffff"
            }),
        tl: {
          hd: Css.opacity(0.66),
          tl: /* [] */0
        }
      });
  var cls3 = Curry._1(Css.style, {
        hd: Css.opacity(0.3),
        tl: /* [] */0
      });
  return React.createElement("svg", {
              id: "Layer_1",
              viewBox: "0 0 46.37 34.51",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("title", undefined, "Glass Trophy"), React.createElement("g", {
                  className: cls3
                }, React.createElement("path", {
                      className: cls1,
                      d: "M46.07,4.41l-.27-1.21h-8.81c-.1-1.05-.28-2-.55-2.88l-.12-.32H10.42l-.1,.37c-.23,.87-.41,1.82-.52,2.84H.57l-.27,1.21c-.48,2.12-.8,6.15,2.35,9.31,1.86,1.86,5.4,3.25,9.29,3.64,1.53,3.53,3.66,6.19,6.24,7.74,.47,.28,.97,.52,1.51,.73v3c-2.87,.93-4.79,2.81-5.15,5.09l-.09,.58h18.45l-.21-.65c-.77-2.39-2.67-4.17-5.38-5.04v-3.25c3.62-1.7,5.88-5.32,7.18-8.19,3.87-.4,7.39-1.79,9.23-3.64,3.15-3.16,2.82-7.19,2.35-9.31ZM10.57,14.35c-2.38-.27-4.2-1.01-5.4-2.22-1.37-1.37-1.94-3.35-1.62-5.58l.06-.43h6.44v.51c-.04,2.36,.33,4.8,1.05,7.07l.24,.74-.77-.09Zm30.71-2.16c-1.23,1.24-3.09,2.01-5.52,2.29l-.79,.09,.26-.75c.81-2.37,1.27-4.98,1.3-7.35v-.49h6.36l.06,.43c.33,2.31-.27,4.36-1.68,5.78Z"
                    })), React.createElement("path", {
                  className: cls1,
                  d: "M32.9,34.51H14.45l.09-.58c.36-2.28,2.28-4.17,5.15-5.09v-3c-.54-.21-1.04-.45-1.51-.73-2.58-1.55-4.71-4.2-6.24-7.74-3.89-.4-7.44-1.78-9.29-3.64C-.5,10.56-.17,6.53,.3,4.41l.27-1.21H9.8c.12-1.01,.29-1.96,.52-2.84l.1-.37h25.89l.12,.32c.27,.88,.45,1.84,.55,2.88h8.81l.27,1.21c.48,2.12,.8,6.15-2.35,9.31-1.85,1.85-5.37,3.24-9.23,3.64-1.29,2.88-3.56,6.5-7.18,8.19v3.25c2.7,.87,4.6,2.65,5.38,5.04l.21,.65Zm-17.24-1h15.83c-.83-1.84-2.51-3.19-4.81-3.85l-.36-.1v-4.65l.3-.13c3.61-1.55,5.84-5.25,7.08-8.08l.12-.27,.29-.03c3.7-.34,7.2-1.66,8.91-3.38,2.81-2.83,2.51-6.47,2.08-8.39l-.1-.43h-8.94l-.04-.46c-.08-1.02-.22-1.94-.44-2.74H11.19c-.2,.85-.35,1.77-.45,2.75l-.04,.45H1.38l-.09,.43c-.43,1.92-.74,5.56,2.08,8.39,1.72,1.73,5.24,3.05,8.97,3.38l.3,.03,.12,.28c1.45,3.47,3.48,6.06,5.87,7.5,.58,.34,1.12,.59,1.66,.78l.33,.12,.07,.38v4.09l-.36,.1c-2.46,.71-4.13,2.08-4.66,3.82ZM34.98,14.58l.26-.75c.81-2.37,1.27-4.98,1.3-7.35v-.49h6.36l.06,.43c.33,2.31-.27,4.36-1.68,5.78-1.23,1.24-3.09,2.01-5.52,2.29l-.79,.09Zm2.55-7.59c-.08,2.08-.46,4.31-1.1,6.4,1.82-.32,3.21-.95,4.14-1.89,1.1-1.11,1.61-2.7,1.45-4.51h-4.5ZM11.34,14.44l-.77-.09c-2.38-.27-4.2-1.01-5.4-2.22h0c-1.37-1.37-1.94-3.35-1.62-5.58l.06-.43h6.44v.51c-.04,2.36,.33,4.8,1.05,7.07l.24,.74Zm-5.46-3.01c.91,.91,2.27,1.52,4.04,1.82-.56-1.99-.86-4.08-.88-6.12H4.49c-.15,1.73,.34,3.24,1.39,4.3h0Z"
                }), React.createElement("ellipse", {
                  className: cls2,
                  cx: "14.89",
                  cy: "10.2",
                  rx: "1.93",
                  ry: "7.07",
                  transform: "translate(-1.3 2.22) rotate(-8.18)"
                }), React.createElement("ellipse", {
                  className: cls2,
                  cx: "20.69",
                  cy: "5.45",
                  rx: "2.34",
                  ry: "2.28"
                }));
}

var Glass = {
  make: WordFlyersTrophies$Glass
};

function trophyToIcon(trophy) {
  switch (trophy) {
    case "Glass" :
        return React.createElement(WordFlyersTrophies$Glass, {});
    case "Bronze" :
        return React.createElement(WordFlyersTrophies$Bronze, {});
    case "Silver" :
        return React.createElement(WordFlyersTrophies$Silver, {});
    case "Gold" :
        return React.createElement(WordFlyersTrophies$Gold, {});
    
  }
}

export {
  Gold ,
  Silver ,
  Bronze ,
  Glass ,
  trophyToIcon ,
}
/* Css Not a pure module */
